const smsCounter = (text, maxSmsNum = 3) => {
  try {
    var
      smsType,
      smsLength = 0,
      smsCount = -1,
      charsLeft = 0,
      isUnicode = false,
      lengths = {
        ascii: [160, 306, 459],
        unicode: [70, 134, 201]
      };

    for (var charPos = 0; charPos < text.length; charPos++) {
      switch (text[charPos]) {
        case "\n":
        case "[":
        case "]":
        case "\\":
        case "^":
        case "{":
        case "}":
        case "|":
        case "€":
          smsLength += 2;
          break;

        default:
          smsLength += 1;
      }

      if (text.charCodeAt(charPos) > 127 && text[charPos] != "€")
        isUnicode = true;
    }

    if (isUnicode) smsType = lengths.unicode;
    else smsType = lengths.ascii;

    for (var sCount = 0; sCount < maxSmsNum; sCount++) {
      if (smsLength <= smsType[sCount]) {
        smsCount = sCount + 1;
        charsLeft = smsType[sCount] - smsLength;
        break
      }
    }

    // smsCount == -1 && (smsCount = maxSmsNum, charsLeft = -1);
    if(smsCount == -1){
      smsCount = maxSmsNum
      charsLeft = -1
    }

    return {
      smsCount,
      charsLeft
    };
  } catch (err) {
    console.log("Error :", err)
  }
}
export default smsCounter;


// WEBPACK FOOTER //
// src/modules/common/utils/smsCounter.js